<template>
  <div>
    <echartMap
      :maps="echartConfig"
      :changeData="changeData"
      v-if="mapConfig.type === 1 ? true : false"
      :isStatus="mapConfig.type === 1 ? true : false"
    ></echartMap>
    <goldenMap
      :searchData="changeData"
      v-if="mapConfig.type === 2 ? true : false"
      :isStatus="mapConfig.type === 2 ? true : false"
      @handleZoom="handleZoom"
      @handleSync="handleSync"
    ></goldenMap>
    <!--        <configDiagr :lineType='lineType' :searchData='changeData' v-if="mapConfig.type===2?true:false"  :isStatus ='mapConfig.type===2?true:false' @handleZoom ='handleZoom' @handleSync ='handleSync'></configDiagr>-->
    <floorDistribution
      v-if="mapConfig.type === 3 ? true : false"
      :isStatus="mapConfig.type === 3 ? true : false"
      @handleZoom="handleZoom"
    ></floorDistribution>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import echartMap from "./echartMap";
import goldenMap from "./baseMap/base_map";
import floorDistribution from "../floor_distribution/floor_main";
import configDiagr from "./configDiagram";

export default {
  name: "main_map",
  props: ["maps", "changeData", "lineType"],
  data() {
    return {
      mapConfig: {
        // map_center:[116.4071700000, 39.9046900000],
        // map_size:10,
        type: null
      },
      echartConfig: {}
    };
  },
  components: {
    echartMap,
    goldenMap,
    floorDistribution,
    configDiagr
  },
  watch: {
    maps: {
      handler(newVal, oldVal) {
        this.handleMapConfig(newVal);
      },
      deep: true
    }
  },
  mounted() {},
  computed: {
    ...mapState(["map_type"])
  },
  methods: {
    ...mapMutations([
      "set_config",
      "set_map_other",
      "setType",
      "set_echart_config"
    ]),
    async handleMapConfig(config) {
      // this.echartConfig = config;

      if (config) {
        //echart地图配置
        console.log("数据展示内容-=-=-=-=config-=", config);

        this.echartConfig = config;
        this.set_echart_config(config);
        var map_other = {
          lnglat: config.mapCenter,
          zoome: config.mapSize?config.mapSize:18,
          cityname: config.cityName,
          Grade: config.showType
        };
        this.set_config(map_other);
        //获取地图类型  1.全国地图  2.高德地图  3.民品高德地图
        this.mapConfig.type = config.mapType;
        // this.mapConfig.type = 3;
        this.setType(config.mapType);
      }
    },
    handleZoom() {
      this.$emit("zoomMap");
    },
    handleSync() {
      this.$emit("syncData");
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/page/main_content/map/main_map.vue